import { useCallback, useState } from 'react';
import { Link } from 'react-router';

import { dayOf, describe } from '../../dates';
import { useLanguage } from '../../contexts/language';
import { useAssignmentChanges } from '../../hooks/assignment-changes';

import styles from './style.module.css';

// One test in a patient's Tests tab. Given an attempt, it is that submitted
// attempt, to review or reviewed, and the row opens its review; otherwise it
// is the assignment waiting for the patient, which the clinician who
// assigned it may withdraw while the patient has not started it. onChange
// reads the list again after a withdrawal; a refusal shows under the row.
export function PatientTestRow({ patientId, assignment, attempt, onChange }) {
  const { text, language, translate } = useLanguage();
  const { withdraw } = useAssignmentChanges();
  const [ busy, setBusy ] = useState(false);
  const [ error, setError ] = useState();
  const { id, questionnaire, assignedBy, mine, createdAt } = assignment;

  const onWithdraw = useCallback(function() {
    setBusy(true);
    setError();

    return withdraw(id).then(function() {
      return onChange();
    }).catch(function(failed) {
      setBusy(false);
      setError(failed.message);
    });
  }, [ id, withdraw, onChange ]);

  const details = [];
  let chip = <span className={ `${ styles.chip } ${ styles.waiting }` }>{ text.notSubmitted }</span>;
  let action = null;

  if (attempt != null) {
    details.push(text.submittedOn.replace('{date}', describe({ day: dayOf(attempt.submittedAt), language, short: true })));
    chip = <span className={ `${ styles.chip } ${ styles.submitted }` }>{ text.toReview }</span>;
  }

  if (attempt != null && attempt.reviewedAt != null) {
    details.push(text.reviewedLower.replace('{date}', describe({ day: dayOf(attempt.reviewedAt), language, short: true })));
    chip = <span className={ styles.chip }>{ text.reviewed }</span>;
  }

  if (attempt == null) {
    details.push(text.assignedOn.replace('{date}', describe({ day: dayOf(createdAt), language, short: true })));
  }

  if (mine === false && assignedBy != null) {
    details.push(text.byClinician.replace('{name}', assignedBy));
  }

  if (attempt == null && mine === true) {
    action = <button className={ styles.action } type='button' disabled={ busy } onClick={ onWithdraw }>{ text.withdraw }</button>;
  }

  let message = null;

  if (error != null) {
    message = <span className={ styles.error } role='alert'>{ translate(error) }</span>;
  }

  if (attempt != null) {
    return (
      <Link className={ styles.row } to={ `/patients/${ patientId }/tests/${ attempt.id }` }>
        <div className={ styles.main }>
          <span className={ styles.lines }>
            <span className={ styles.name }>{ questionnaire.name }</span>
            <span className={ styles.detail }>{ details.join(' · ') }</span>
          </span>

          { chip }

          <span className={ styles.chevron } aria-hidden='true'></span>
        </div>
      </Link>
    );
  }

  return (
    <div className={ styles.row }>
      <div className={ styles.main }>
        <span className={ styles.lines }>
          <span className={ styles.name }>{ questionnaire.name }</span>
          <span className={ styles.detail }>{ details.join(' · ') }</span>
        </span>

        { chip }

        { action }
      </div>

      { message }
    </div>
  );
}
